export default __webpack_public_path__ + "static/media/Gene_X_Normal_Length_Control_DNA.0c726db1.svg";